export default "__VITE_ASSET__e42c3978__"